import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "../locales/en.json";
import fr from "../locales/fr.json";
import { detectLocaleFromURL, switchLocaleURL } from "./locale";
import type { SupportedLocale } from "./locale";

function initialLanguage(): SupportedLocale {
	const fromUrl = detectLocaleFromURL();
	if (window.location.pathname.startsWith("/app") || window.location.pathname.startsWith("/fr/app")) {
		return fromUrl;
	}
	const saved = localStorage.getItem("kitsulab_lang");
	return saved === "fr" || saved === "en" ? saved : fromUrl;
}

void i18n.use(initReactI18next).init({
	resources: {
		fr: { translation: fr },
		en: { translation: en },
	},
	lng: initialLanguage(),
	fallbackLng: "en",
	interpolation: { escapeValue: false },
});

export function setLanguage(lang: SupportedLocale): void {
	localStorage.setItem("kitsulab_lang", lang);
	window.location.href = switchLocaleURL(lang);
}

export default i18n;
